// extracted by mini-css-extract-plugin
export default {"textContainer":"_3VbVbip2gIytbts60k36Eq","buttonsContainer":"_3PRb4atWkL0IFgFxOtN7_A","noBorderBottom":"_1VSWvC6MgUg9RYXqZahrpN"};